import React, {useCallback, useMemo} from 'react';
import {Modal} from 'antd';
import {useSideBarModal} from '../../../../layout/common/useSideBarModal';
import ModelRetire from './ModelRetire';
import {ModelActionProps} from '../../../actionMenuTypes';

export const useModelRetireSideBarModal = (props: Partial<ModelActionProps>) => {
  const {model, onSuccess} = props;
  const {buttonRef, openModal, closeModal} = useSideBarModal(model?.uuid);

  const handleSuccess = useCallback(() => {
    closeModal();
    onSuccess?.();
  }, [closeModal, onSuccess]);

  const ModalComponent = useMemo(() => {
    return (
      model && (
        <Modal
          open={!!buttonRef}
          onCancel={closeModal}
          footer={null}
          title={null}
          width={680}
          centered
          closable={false}
          maskClosable={false}
          destroyOnHidden
          bodyStyle={{
            padding: '3rem 2rem 2rem 5rem',
          }}
        >
          {!!buttonRef && <ModelRetire model={model} onSuccess={handleSuccess} onCancel={closeModal} />}
        </Modal>
      )
    );
  }, [buttonRef, model, handleSuccess, closeModal]);

  return {
    openModal,
    ModalComponent,
  };
};
